<p-dialog i18n-header [closable]="false" [(visible)]="displayIdleDialog" header="System Inactivity Timeout" [modal]="true" [style]="{width: '500'}" >
  <p i18n>
    You have been inactive in {{productName}} for {{inactiveMinutes}} minutes.
  </p>
  <strong class="mb-2">
    <span i18n>Your session will expire in</span>
    <span class="inactiveCountdown">{{timeLeft}}</span>
    <span i18n>minutes.</span>
  </strong>
  <p-footer>
    <button i18n type="button" id="continueworking" class="btn btn-primary" (click)="continueWorking()">Continue Working</button>
    <button i18n type="button" id="logmeout" class="btn btn-primary" (click)="logMeOut()">Log Me Out</button>
  </p-footer>
</p-dialog>
